import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from "../../../customComponents/Footer";
import "./otc-service.css";

const OtcServicePage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const miniServices = [
        {
            icon: "/images/otc_service-img/otc_service_icon.svg",
            title: "Institutional Trading",
        },
        {
            icon: "/images/otc_service-img/otc_service_icon2.svg",
            title: "Stable Pricing",
        },
        {
            icon: "/images/otc_service-img/otc_service_icon3.svg",
            title: "Fast & Trusted",
        },
        {
            icon: "/images/otc_service-img/otc_service_icon4.svg",
            title: "Crypto Settlement",
        },
        {
            icon: "/images/otc_service-img/otc_service_icon.svg",
            title: "Relationship Manager",
        },
    ];

    const detailedServices = [
        {
            icon: "/images/otc_service-img/block_trading_icon.svg",
            title: "Block Trading",
            desc: "Trade large blocks of crypto assets with minimal market impact and guaranteed execution at agreed prices.",
        },
        {
            icon: "/images/otc_service-img/fiat_crypto.svg",
            title: "Fiat to Crypto",
            desc: "Seamlessly convert fiat currencies into crypto assets at competitive rates with full compliance coverage.",
        },
        {
            icon: "/images/otc_service-img/fiat_crypto2.svg",
            title: "Crypto to Fiat",
            desc: "Convert your crypto holdings to fiat quickly with real-time pricing and bank wire settlement.",
        },
        {
            icon: "/images/otc_service-img/institutional_solutions_icon.svg",
            title: "Institutional Solutions",
            desc: "Tailored OTC solutions for hedge funds, family offices and corporate treasuries at institutional scale.",
        },
        {
            icon: "/images/otc_service-img/corporate_solutions_icon.svg",
            title: "Corporate Solutions",
            desc: "Structured crypto treasury solutions and risk management services for corporate clients globally.",
        },
        {
            icon: "/images/otc_service-img/mining_treasury_icon.svg",
            title: "Mining & Treasury",
            desc: "OTC solutions purpose-built for miners and crypto treasury teams managing large asset positions.",
        },
    ];

    const processSteps = [
        {
            num: "01",
            title: "Contact Our Desk",
            desc: "Reach out to our OTC team via the contact form or dedicated hotline.",
        },
        {
            num: "02",
            title: "Submit Your RFQ",
            desc: "Provide trade details including pair, side, and both pay and receive amounts.",
        },
        {
            num: "03",
            title: "Receive Best Quote",
            desc: "Our brokers find the best available rate for your request size.",
        },
        {
            num: "04",
            title: "Settle & Confirm",
            desc: "Accept the desk quote to lock funds; the desk then settles the trade.",
        },
    ];

    return (
        <>
            <Helmet>
                <title>OTC Service | Professional Crypto OTC Solutions</title>
                <meta
                    name="description"
                    content="Professional OTC solutions for institutions, businesses and high net worth individuals worldwide on AGCX."
                />
            </Helmet>

            <div className="otc-service-page">
                <div className="otc_hero_section">
                    <div className="otc-service-container">
                        <div className="otc-service-hero">
                            <div className="otc-service-hero-left">
                                <h1 className="otc-service-hero-title">
                                    OTC <span className="gold-text">Service</span>
                                </h1>
                                <p className="otc-service-hero-desc">
                                    Professional OTC solutions for institutions, businesses and high net worth individuals worldwide.
                                </p>
                                <div className="otc-service-hero-btns">
                                    <a href="#contact-section" className="btn-contact-us">
                                        Contact Us
                                    </a>
                                    <Link to="/otc" className="link-learn-more">
                                        OTC &amp; Execution ›
                                    </Link>
                                </div>
                            </div>

                            <div className="otc-service-hero-right">
                                <img
                                    src="/images/otc_service-img/otc_service_bnr.png"
                                    alt="OTC Service 3D Globe Illustration"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="otc-service-container">


                    <div className="our-otc-services-section" id="services-section">
                        <h2 className="our-otc-title">Our OTC Services</h2>

                        <div className="mini-services-grid">
                            {miniServices.map((item, idx) => (
                                <div className="mini-service-card" key={idx}>
                                    <div className="mini-icon-box">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <span>{item.title}</span>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>

                <div className="otcservices_list">
                    <div className="otc-service-container">

                        <div className="detailed-services-grid">
                            {detailedServices.map((item, idx) => (
                                <div className="service-feature-card" key={idx}>
                                    <div className="feature-icon-box">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>




                <div className="otc-process-section">
                    <div className="otc-service-container">
                        <h2 className="process-title">OTC Service Process</h2>

                        <div className="process-grid-4col">
                            {processSteps.map((step, idx) => (
                                <div className="process-card" key={idx}>
                                    <div className="process-num">{step.num}</div>
                                    <h4>{step.title}</h4>
                                    <p>{step.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="otc_process_img">
                        <img src="/images/otc_service-img/otc_process_bg.png" alt="" />
                    </div>

                </div>

                {/* ========================================== */}
                {/* --- 5. CTA BANNER --- */}
                {/* ========================================== */}
                <div className="otc-service-container">
                    <div className="partner-cta-section" id="contact-section">
                        <div className="partner-cta-card">
                            <h2>Partner with a Trusted OTC Desk</h2>
                            <p>
                                Our dedicated OTC brokers are available 24/7 to execute large trades with full discretion and speed.
                            </p>
                            <Link to="/contact" className="btn-contact-desk">
                                Contact Our Desk
                            </Link>
                        </div>
                    </div>

                </div>
            </div >

            <Footer />
        </>
    );
};

export default OtcServicePage;
